<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="物联网IMEI卡号" v-model="imei"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="物联网IMSI卡号" v-model="imsi"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="data"
      border
      row-key="id"
      stripe
      style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="deviceId" label="设备编号" width="160">
      </el-table-column>
      <el-table-column prop="devAlias" label="设备名称"> </el-table-column>
      <el-table-column prop="institution" label="机构/个人"> </el-table-column>
      <el-table-column
        prop="verHw"
        :label="'ver_hw/硬件版本号/模组软件版号/MCU软件版本号'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="verMcu"
        :label="'ver_mcu/MCU软件版本号'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="verSw"
        :label="'ver_sw/模组软件版号'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="imei"
        :label="'imei/物联网IMEI卡号'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="imsi"
        :label="'imsi/物联网IMSI卡号'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column prop="lastReportTime" label="最近上报数据时间">
      </el-table-column>
      <el-table-column fixed="right" label="操作" >
        <template slot-scope="scope" >
        <div class="cell1">
          <router-link v-for="(item,index) in linkList" :key="index"
            :to="item.path + scope.row.deviceId"
          >
            <el-button type="text" size="small">{{item.label}}</el-button>

          </router-link>
          </div>
        </template>
        
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      imei: "",
      imsi: "",
      data: [],
      linkList: [
        { label: "查看历史数据", path: "/equipment/internationalGPS/equi/lishi/" },
        { label: "上传车辆状态", path: "/equipment/internationalGPS/equi/zhuangtai/" },
        { label: "上传设备登陆信息", path: "/equipment/internationalGPS/equi/longin/" },
        { label: "上传配置参数信息", path: "/equipment/internationalGPS/equi/peizhi/" },
        { label: "上传设备日志", path: "/equipment/internationalGPS/equi/rizhi/" },
        { label: "下发设备指令", path: "/equipment/internationalGPS/equi/downEqIns/" },
        { label: "下发配置指令", path: "/equipment/internationalGPS/equi/downCfgIns/" },
        { label: "OTA升级", path: "/equipment/internationalGPS/equi/ota/" },
      ],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.imei.trim() != "") {
        params.imei = this.imei;
      }
      if (this.imsi.trim() != "") {
        params.imsi = this.imsi;
      }
      this.$http
        .post(`${this.env}/manage/device-mqtt-uplink/list`, params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },
    renderheader(h, { column }) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1]),
        h("br"),
        h("span", {}, column.label.split("/")[2]),
        h("br"),
        h("span", {}, column.label.split("/")[3]),
      ]);
    },
  },
  components: { Pagination },
};
</script>
  
  <style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
.cell1 {
  display: flex !important;
  flex-direction: column !important;
}
</style>